import camera1 from '../../../assets/Camera/camera (1).jpg';
import camera2 from '../../../assets/Camera/camera (2).jpg';
import camera3 from '../../../assets/Camera/camera (3).jpg';
import camera4 from '../../../assets/Camera/camera (4).jpg';
import camera5 from '../../../assets/Camera/camera (5).jpg';
import camera6 from '../../../assets/Camera/camera (6).jpg';
import camera7 from '../../../assets/Camera/camera (7).jpg';
import camera8 from '../../../assets/Camera/camera (8).jpg';
import camera9 from '../../../assets/Camera/camera (9).jpg';
import camera10 from '../../../assets/Camera/camera (10).jpg';
import camera11 from '../../../assets/Camera/camera (11).jpg';
import camera12 from '../../../assets/Camera/camera (12).jpg';
import camera13 from '../../../assets/Camera/camera (13).jpg';
import camera14 from '../../../assets/Camera/camera (14).jpg';
import camera15 from '../../../assets/Camera/camera (15).jpg';
import camera16 from '../../../assets/Camera/camera (16).jpg';
import camera17 from '../../../assets/Camera/camera (17).jpg';
import camera18 from '../../../assets/Camera/camera (18).jpg';
import camera19 from '../../../assets/Camera/camera (19).jpg';

export const galleryImages = [
  {
    id: 1,
    title: "Pemandangan Gunung",
    camera: "Samsung Galaxy A12",
    image: camera1,
    category: "Langit",
    date: "15 Juni 2023",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 2,
    title: "Senja di Pantai",
    camera: "Samsung Galaxy A12",
    image: camera2,
    category: "Art",
    date: "20 Juli 2023",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 3,
    title: "Kota di Malam Hari",
    camera: "Samsung Galaxy A12",
    image: camera3,
    category: "Langit",
    date: "5 Agustus 2023",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 4,
    title: "Air Terjun Indah",
    camera: "Samsung Galaxy A12",
    image: camera4,
    category: "Langit",
    date: "12 September 2023",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 5,
    title: "Hutan Pagi Hari",
    camera: "Samsung Galaxy A12",
    image: camera5,
    category: "Transportasi Umum",
    date: "18 Oktober 2023",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 6,
    title: "Jalanan Kota Lama",
    camera: "Samsung Galaxy A12",
    image: camera6,
    category: "Bangunan",
    date: "25 November 2023",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 7,
    title: "Danau Tenang",
    camera: "Samsung Galaxy A12",
    image: camera7,
    category: "Alam",
    date: "2 Desember 2023",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 8,
    title: "Gedung Bersejarah",
    camera: "Samsung Galaxy A12",
    image: camera8,
    category: "Bangunan",
    date: "10 Januari 2024",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 9,
    title: "Pemandangan Sawah",
    camera: "Samsung Galaxy A12",
    image: camera9,
    category: "Alam",
    date: "17 Februari 2024",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 10,
    title: "Jembatan Ikonik",
    camera: "Samsung Galaxy A12",
    image: camera10,
    category: "Art",
    date: "23 Maret 2024",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 11,
    title: "Pantai Berbatu",
    camera: "Samsung Galaxy A12",
    image: camera11,
    category: "Jalanan",
    date: "5 April 2024",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 12,
    title: "Kebun Teh",
    camera: "Samsung Galaxy A12",
    image: camera12,
    category: "Alam",
    date: "14 Mei 2024",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 13,
    title: "Gedung Pencakar Langit",
    camera: "Samsung Galaxy A12",
    image: camera13,
    category: "Kota",
    date: "22 Juni 2024",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 14,
    title: "Pantai Pasir Putih",
    camera: "Samsung Galaxy A12",
    image: camera14,
    category: "Pantai",
    date: "30 Juli 2024",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 15,
    title: "Gunung di Pagi Hari",
    camera: "Samsung Galaxy A12",
    image: camera15,
    category: "Alam",
    date: "8 Agustus 2024",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 16,
    title: "Jalanan Malam",
    camera: "Samsung Galaxy A12",
    image: camera16,
    category: "Kota",
    date: "16 September 2024",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 17,
    title: "Pantai Senja",
    camera: "Samsung Galaxy A12",
    image: camera17,
    category: "Pantai",
    date: "24 Oktober 2024",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 18,
    title: "Bukit Hijau",
    camera: "Samsung Galaxy A12",
    image: camera18,
    category: "Alam",
    date: "2 November 2024",
    location: "Bogor, Jawa Barat"
  },
  {
    id: 19,
    title: "Kota di Senja Hari",
    camera: "Samsung Galaxy A12",
    image: camera19,
    category: "Kota",
    date: "10 Desember 2024",
    location: "Bogor, Jawa Barat"
  }
];

export const getOptimalImageSize = (imgWidth, imgHeight, maxWidth = 1200, maxHeight = 800) => {
  const ratio = Math.min(maxWidth / imgWidth, maxHeight / imgHeight, 1);
  return {
    width: imgWidth * ratio,
    height: imgHeight * ratio
  };
};

// export const categories = [
//   { value: 'all', label: 'Semua Kategori' },
//   { value: 'Langit', label: 'Langit' },
//   { value: 'Alam', label: 'Alam' },
//   { value: 'Kota', label: 'Kota' },
//   { value: 'Pantai', label: 'Pantai' },
//   { value: 'Bangunan', label: 'Bangunan' },
//   { value: 'Jalanan', label: 'Jalanan' },
//   { value: 'Art', label: 'Art' },
//   { value: 'Transportasi Umum', label: 'Transportasi Umum' }
// ];